import React from 'react';
import {faExclamationTriangle} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button} from 'antd';
import {HomeOutlined} from '@ant-design/icons';
import {PaperLayout} from "./styled/PaperLayout";
import {Text} from "./styled/Text";
import {Flex} from "./styled/Flex";
import {useHistory, useLocation} from "react-router";
import {ROOT_REDIRECT} from "./ReservedSwitcher";
import {HorizontalLayout} from "../layout/HorizontalLayout";

interface MissingPathInterface {
}

const MissingPath: React.FC<MissingPathInterface> = (props) => {
    const history = useHistory();
    const location = useLocation();
    return (
        <PaperLayout asCard={true}>
            <HorizontalLayout>
                <Flex direction={'horizontal'} justify={'flex-start'}>
                    <span style={{backgroundColor: 'red', padding: '5px'}}><FontAwesomeIcon icon={faExclamationTriangle} color={'white'} size={'2x'}/></span>
                    <Text paddingLeft={'10pt'}>{'Percorso Inesistente' +':'}</Text>
                    <Text paddingLeft={'10pt'} fontWeight={'800'}>{location.pathname}</Text>
                </Flex>
                <Button
                    type={'primary'}
                    shape={'circle'}
                    icon={<HomeOutlined/>}
                    onClick={() => {
                        history.push(ROOT_REDIRECT);
                    }}
                />
            </HorizontalLayout>
        </PaperLayout>
    )
};

export default MissingPath;